import type { ReactNode } from "react";

/**
 * A single mandatory pre-test consent checkbox. The label text (and any links,
 * e.g. to the candidate privacy notice) is passed as children.
 */
export function ConsentCheckbox({
  checked,
  onChange,
  children,
}: {
  checked: boolean;
  onChange: (checked: boolean) => void;
  children: ReactNode;
}) {
  return (
    <label className="flex cursor-pointer items-start gap-3 py-1 text-sm text-foreground/90">
      <input
        type="checkbox"
        checked={checked}
        onChange={(e) => onChange(e.target.checked)}
        className="mt-0.5 size-4 shrink-0 cursor-pointer accent-primary"
      />
      <span>{children}</span>
    </label>
  );
}
